/**
 * PM CRM form helpers — inline create toggles, CC suggestions.
 * Uses event delegation so it works across sheet open/close cycles.
 */

(function () {

    function toggleContactEmailForm(show) {
        var form = document.getElementById('contact-email-form');
        var addBtn = document.querySelector('.js-contact-email-add-btn');
        if (show) {
            form.style.display = '';
            form.querySelector('input').focus();
            if (addBtn) addBtn.style.display = 'none';
        } else {
            form.style.display = 'none';
            if (addBtn) addBtn.style.display = '';
        }
    }

    function toggleContactPhoneForm(show) {
        var form = document.getElementById('contact-phone-form');
        var addBtn = document.querySelector('.js-contact-phone-add-btn');
        if (show) {
            form.style.display = '';
            form.querySelector('input').focus();
            if (addBtn) addBtn.style.display = 'none';
        } else {
            form.style.display = 'none';
            if (addBtn) addBtn.style.display = '';
        }
    }

    function toggleOwnerCreate(show) {
        var typeahead = document.getElementById('owner-typeahead');
        var create = document.getElementById('owner-inline-create');
        if (!typeahead || !create) return;
        if (show) {
            var q = typeahead.querySelector('.typeahead-input');
            var nameInput = create.querySelector('[name=owner_name]');
            if (q && nameInput) nameInput.value = q.value;
            typeahead.style.display = 'none';
            create.style.display = '';
            if (nameInput) nameInput.focus();
        } else {
            create.style.display = 'none';
            typeahead.style.display = '';
            var input = typeahead.querySelector('.typeahead-input');
            if (input) input.focus();
        }
    }


    // Show selected owner and hide search mode
    function showOwnerSelected(name) {
        var searchMode = document.getElementById('owner-search-mode');
        var selected = document.getElementById('owner-selected');
        if (searchMode) searchMode.style.display = 'none';
        if (selected) {
            // Only build markup if HTMX hasn't already swapped in content (inline create path)
            if (!selected.querySelector('.list-group-item')) {
                selected.innerHTML =
                    '<div class="list-group mb-0"><div class="list-group-item">' +
                    '<div class="list-item-content"><div class="list-item-title">' +
                    name.replace(/</g, '&lt;') + '</div></div>' +
                    '<div class="list-item-meta">' +
                    '<button type="button" class="btn-ghost btn-xs" data-action="clear-owner-selection">Change</button>' +
                    '</div></div></div>';
            }
            selected.style.display = '';
        }
    }

    // Typeahead selection → toggle to selected state
    document.body.addEventListener('typeahead:select', function (e) {
        var container = e.target.closest('.typeahead');
        if (!container || container.getAttribute('data-typeahead-target') !== 'owner') return;
        var d = e.detail || {};
        if (!d.id) return;
        showOwnerSelected(d.name || '');
    });

    // Intercept ownerCreated when it originates inside a form with an owner typeahead
    // (inline create on lead/prospect sheets). Capture phase fires before the generic
    // htmx-actions body handler that would otherwise open the owner detail sheet.
    document.body.addEventListener('ownerCreated', function (e) {
        var form = e.target.closest('form');
        if (!form || !form.querySelector('[data-typeahead-target=owner]')) return;

        e.stopPropagation();

        var d = e.detail || {};
        var id = d.ownerId || d.value;
        if (!id) return;

        // Set the hidden owner input
        var hidden = form.querySelector('input[name=owner]');
        if (hidden) hidden.value = id;

        // Toggle to selected state (partial swapped by HTMX into #owner-selected)
        showOwnerSelected(d.ownerName || '');

        // Reset inline create form
        var create = document.getElementById('owner-inline-create');
        if (create) {
            create.querySelectorAll('input').forEach(function (el) { el.value = ''; });
            create.style.display = 'none';
        }
    }, true);

    function clearOwnerSelection() {
        var searchMode = document.getElementById('owner-search-mode');
        var selected = document.getElementById('owner-selected');
        var typeahead = document.getElementById('owner-typeahead');
        if (selected) { selected.innerHTML = ''; selected.style.display = 'none'; }
        if (searchMode) searchMode.style.display = '';
        if (typeahead) {
            typeahead.style.display = '';
            var hidden = typeahead.querySelector('input[name=owner]');
            if (hidden) hidden.value = '';
            var inp = typeahead.querySelector('.typeahead-input');
            if (inp) { inp.value = ''; inp.focus(); }
            var clearBtn = typeahead.querySelector('.typeahead-clear-btn');
            if (clearBtn) clearBtn.style.display = 'none';
        }
    }

    // CC chips — "Add" button in dropdown adds checked suggestions as chips
    function addCcChip(chipsContainer, email, name) {
        // Don't add duplicates
        if (chipsContainer.querySelector('[data-cc-email="' + CSS.escape(email) + '"]')) return;
        var chip = document.createElement('span');
        chip.className = 'chip chip-sm';
        chip.setAttribute('data-cc-email', email);
        var icon = document.createElement('i');
        icon.className = 'fa-solid fa-envelope fa-xs';
        chip.appendChild(icon);
        chip.appendChild(document.createTextNode(' ' + (name || email)));
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'cc';
        hidden.value = email;
        chip.appendChild(hidden);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'chip-dismiss js-cc-chip-remove';
        btn.innerHTML = '<i class="fa-solid fa-xmark"></i>';
        chip.appendChild(btn);
        chipsContainer.appendChild(chip);
    }

    // "Add" button in CC dropdown — add checked suggestions as chips
    document.body.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-cc-add');
        if (!btn) return;
        var dropdown = btn.closest('.dropdown-menu');
        if (!dropdown) return;
        var row = btn.closest('[data-cc-row]');
        if (!row) return;
        var chipsContainer = row.querySelector('[data-cc-chips]');
        if (!chipsContainer) return;

        dropdown.querySelectorAll('.js-cc-suggestion:checked').forEach(function (cb) {
            addCcChip(chipsContainer, cb.getAttribute('data-email'), cb.getAttribute('data-name'));
            cb.checked = false;
        });

        // Close dropdown
        if (window.SeeMe && SeeMe.dropdowns) SeeMe.dropdowns.closeAll();
    });

    // Remove CC chip
    document.body.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-cc-chip-remove');
        if (!btn) return;
        var chip = btn.closest('[data-cc-email]');
        if (chip) chip.remove();
    });

    // Manual CC entry — add chip on Enter or blur
    document.body.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        var input = e.target.closest('[data-cc-manual]');
        if (!input) return;
        e.preventDefault();
        var email = input.value.trim();
        if (!email) return;
        var row = input.closest('[data-cc-row]');
        var chipsContainer = row && row.querySelector('[data-cc-chips]');
        if (!chipsContainer) return;
        addCcChip(chipsContainer, email, '');
        input.value = '';
    });

    document.body.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-action]');
        if (!btn) return;
        var action = btn.getAttribute('data-action');

        if (action === 'toggle-owner-create') toggleOwnerCreate(true);
        else if (action === 'cancel-owner-create') toggleOwnerCreate(false);
        else if (action === 'add-contact-email') toggleContactEmailForm(true);
        else if (action === 'cancel-contact-email') { e.preventDefault(); toggleContactEmailForm(false); }
        else if (action === 'add-contact-phone') toggleContactPhoneForm(true);
        else if (action === 'cancel-contact-phone') { e.preventDefault(); toggleContactPhoneForm(false); }
        else if (action === 'clear-owner-selection') clearOwnerSelection();
    });

})();
